import React from 'react';
import { Quote } from 'lucide-react';
import { testimonial, HEAVY_IMAGE } from '../mock/mock';

const Testimonial = () => {
  return (
    <section className="relative bg-white py-28 lg:py-36">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-5 relative">
            <div className="relative aspect-[4/5] overflow-hidden bg-neutral-900">
              <img
                src={HEAVY_IMAGE}
                alt="Caprock heavy haul"
                className="absolute inset-0 w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-1000"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 flex items-center justify-between text-white">
                <span className="font-mono-tech text-[10px] tracking-[0.3em] uppercase">Field 007</span>
                <span className="font-mono-tech text-[10px] tracking-[0.3em] uppercase">TX · US</span>
              </div>
            </div>
            {/* frame corners */}
            <span className="absolute -top-2 -left-2 w-4 h-4 border-t-[1.5px] border-l-[1.5px] border-black" />
            <span className="absolute -top-2 -right-2 w-4 h-4 border-t-[1.5px] border-r-[1.5px] border-black" />
            <span className="absolute -bottom-2 -left-2 w-4 h-4 border-b-[1.5px] border-l-[1.5px] border-black" />
            <span className="absolute -bottom-2 -right-2 w-4 h-4 border-b-[1.5px] border-r-[1.5px] border-black" />
          </div>

          <div className="lg:col-span-7 lg:pl-8">
            <div className="flex items-center gap-3 mb-8">
              <span className="w-8 h-[1.5px] bg-black/60" />
              <span className="font-mono-tech text-[10px] tracking-[0.3em] uppercase text-black/60">
                Our Partners
              </span>
            </div>
            <Quote className="w-10 h-10 text-black mb-6" strokeWidth={1.5} />
            <blockquote className="font-display font-medium text-[28px] sm:text-[34px] lg:text-[40px] leading-[1.15] text-black">
              “{testimonial.quote}”
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
